<template>
  <ProductPageLayout
    name="芊荨音视频转换器"
    :logo="logo"
    :hero-image="heroImage"
    lead="支持主流视频和音频格式互转，面向创作者和日常办公的高效转码工具。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/videocvt/VideoCvtSetup.exe"
    download-file-name="VideoCvtSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="视频转换、合并、分割与水印，满足创作与办公转码需求。"
    other-desc="更多媒体处理能力，覆盖日常视频与音频处理场景。"
    reviews-desc="真实反馈持续驱动音视频转换器体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'VideoConverter',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/videocvt/videovc_48x48.png'),
      heroImage: require('@/assets/videocvt/mainpage.png'),
      featureLines: [
        '视频转换 / 视频合并 / 视频分割 / 视频水印',
        '音频转换 / 视频压缩 / 视频转 GIF / 视频美化'
      ],
      metaItems: [
        { icon: 'video', label: '多格式支持' },
        { icon: 'fast', label: '批量处理' },
        { icon: 'sparkle', label: '高清输出' }
      ],
      detailedFeatures: [
        {
          title: '视频转换',
          brief: '一键完成主流视频格式互转，输出结果稳定。',
          detail: '支持 MP4、MOV、AVI、MKV、FLV 等常见格式，批量导入后自动连续处理，适合高频转码场景。',
          image: require('@/assets/videocvt/feature_convert.png')
        },
        {
          title: '视频合并',
          brief: '多段素材快速拼接，生成完整成片。',
          detail: '可按顺序合并多个片段，统一输出分辨率与编码参数，减少二次剪辑的重复劳动。',
          image: require('@/assets/videocvt/feature_split.png')
        },
        {
          title: '视频水印',
          brief: '支持文字与图片水印，保护内容版权。',
          detail: '可自定义水印位置、透明度和大小，适用于教学内容、品牌内容以及社媒分发场景。',
          image: require('@/assets/videocvt/视频水印.png')
        },
        {
          title: '视频分割',
          brief: '长视频按片段拆分，导出更灵活。',
          detail: '支持按时间段切割视频，快速提取精彩片段或按章节拆分，便于发布和归档。',
          image: require('@/assets/videocvt/feature_split.png')
        }
      ],
      otherFeatures: [
        { title: '视频压缩', description: '在保持清晰度前提下显著减小体积，上传与存储更省空间。', iconImage: require('@/assets/videocvt/video_compress.png') },
        { title: '视频转GIF', description: '把视频片段快速转成动图素材，便于社媒传播和产品演示。', iconImage: require('@/assets/videocvt/video_2gif.png') },
        { title: '视频美化', description: '支持亮度、对比度、饱和度等基础调节，快速优化视频观感。', iconImage: require('@/assets/videocvt/video_beauty.png') },
        { title: '音频转换', description: '支持音频提取与多格式转换，满足剪辑、归档和分享需求。', iconImage: require('@/assets/videocvt/audio_convert.png') }
      ],
      reviews: [
        { name: '张先生', comment: '转换速度很快，批量任务非常稳定，做课程视频时节省了很多时间。', avatar: require('@/assets/videocvt/avatar1.jpg') },
        { name: '王女士', comment: '界面清晰，功能集中，视频转音频和压缩都很好用，基本每天都会用到。', avatar: require('@/assets/videocvt/avatar2.jpg') },
        { name: '李同学', comment: '做作业视频剪辑后导出不同格式很方便，画质保持也比我预期更好。', avatar: require('@/assets/videocvt/avatar3.jpg') },
        { name: '陈老师', comment: '课堂录屏转码和分割功能很好，操作路径短，新手也能很快上手。', avatar: require('@/assets/videocvt/avatar4.jpeg') },
        { name: '赵工程师', comment: '参数可调范围够用，输出稳定，对我们日常演示素材处理很友好。', avatar: require('@/assets/videocvt/avatar5.jpeg') },
        { name: '刘设计', comment: '视频转 GIF 的效果不错，搭配美化功能做社媒素材非常高效。', avatar: require('@/assets/videocvt/avatar6.jpeg') }
      ]
    }
  }
}
</script>
